export default () => (
  <svg
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <rect x='3' y='4' width='10' height='2' rx='1' fill='#5A607F' />
    <rect x='3' y='8.5' width='10' height='2' rx='1' fill='#5A607F' />
    <rect x='3' y='13' width='10' height='2' rx='1' fill='#5A607F' />
    <g transform='translate(13, 12)'>
      <rect
        x='0.5'
        y='2'
        width='5'
        height='4.5'
        rx='1'
        stroke='#5A607F'
        strokeWidth='1.2'
      />
      <path
        d='M2.5 2V1.25C2.5 0.56 3.06 0 3.75 0C4.44 0 5 0.56 5 1.25V2'
        stroke='#5A607F'
        strokeWidth='1.2'
        strokeLinecap='round'
      />
    </g>
  </svg>
);
